import { Route, Routes } from 'react-router-dom';
import { LayoutShell } from '../shared/Layout.tsx';
import { CambiarClavePage } from '../shared/CambiarClave.tsx';
import { MisSolicitudesPage } from './MisSolicitudes.tsx';
import { NuevaSolicitudPage } from './NuevaSolicitud.tsx';
import { DetalleSolicitudPage } from './DetalleSolicitud.tsx';
import { HistorialPage } from './Historial.tsx';
import { ServiciosPage } from './Servicios.tsx';
import { SalonesPage } from './Salones.tsx';
import { AyudaClientePage } from './Ayuda.tsx';

const nav = [
  { to: '/cliente', label: 'Mis solicitudes', icon: 'event_available' },
  { to: '/cliente/nueva', label: 'Nueva solicitud', icon: 'add_circle' },
  { to: '/cliente/servicios', label: 'Servicios', icon: 'receipt_long' },
  { to: '/cliente/historial', label: 'Historial', icon: 'history' },
  { to: '/cliente/salones', label: 'QR', icon: 'qr_code' },
];

export function ClienteApp() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <LayoutShell
            titulo="Portal Cliente"
            items={nav}
            accent="verde"
            fabTo="/cliente/nueva"
            ayudaTo="/cliente/ayuda"
            cuentaTo="/cliente/cuenta"
          />
        }
      >
        <Route index element={<MisSolicitudesPage />} />
        <Route path="nueva" element={<NuevaSolicitudPage />} />
        <Route path="solicitud/:id" element={<DetalleSolicitudPage />} />
        <Route path="servicios" element={<ServiciosPage />} />
        <Route path="historial" element={<HistorialPage />} />
        <Route path="salones" element={<SalonesPage />} />
        <Route path="ayuda" element={<AyudaClientePage />} />
        <Route path="cuenta" element={<CambiarClavePage />} />
      </Route>
    </Routes>
  );
}
